import React from "react";
import { Outlet } from "react-router";
import Navigation from "./navigation";
import styles from "./layout.module.css";
import useIsMobile from "hooks/detect-mobile-screen";
import MobileNavigation from "./mobile/mobile-navigation";

const Layout = () => {
  const isMobile = useIsMobile();

  return (
    <div className={styles.layout}>
      {!isMobile && <Navigation />}
      <Outlet />
      {isMobile && <MobileNavigation />}
    </div>
  );
};

export default Layout;
